module.exports = __webpack_public_path__ + "img/Group 6286@2x.8190853a.png";